import { PILL_TYPE } from 'src/components/BeaconV2Components/GenericSidebarNav/constants';
import saveAs from 'file-saver';
import { DataObject } from './types';
import Papa from 'papaparse';

export const getEntityDisplayNames = (entityType: string, retailerSku?: string): string => {
  switch (entityType) {
    case 'company':
    case 'client':
      return PILL_TYPE.ORGANIZATION.toLowerCase();
    case 'product':
      return `${retailerSku} product`;
    case 'category':
      return PILL_TYPE.CATEGORY.toLowerCase();
    case 'brand':
      return PILL_TYPE.BRAND.toLowerCase();
    case 'subcategory':
      return PILL_TYPE.SUBCATEGORY.toLowerCase();
    case 'businessunit':
      return PILL_TYPE.BUSINESS_UNIT.toLowerCase();
    case 'adEntity':
      return 'entity';
    case 'adPortfolio':
      return 'portfolio';
    case 'adGroup':
      return PILL_TYPE.AD_GROUP.toLowerCase();
    case 'adCampaign':
      return 'campaign';
    case 'adTarget':
      return PILL_TYPE.AD_TARGET.toLowerCase();
    default:
      return null;
  }
};

export const downloadFile = async (arr: DataObject[], fileName: string): Promise<void> => {
  if (!Array.isArray(arr) || arr.length === 0) {
    console.error('Invalid or empty data array.');
    return;
  }

  try {
    const parseData = arr.map((data) => ({
      Product: data?.additionalMetaData?.product?.title || 'N/A',
      'Retailer SKU': data?.additionalMetaData?.product?.retailerSku || 'N/A',
      Status: data?.additionalValues?.statusReason || 'N/A',
      'Ad Clicks': data?.additionalValues?.clicks_sum_value || 0,
      'Ad Spend': data?.additionalValues?.spend_sum_value || 0,
      'Ad Sales': data?.additionalValues?.sales_sum_value || 0,
      ROAS: data?.additionalValues?.returnOnAdSpend_computed_value || 0
    }));

    const csv = Papa.unparse(parseData);

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, `${fileName}.csv`);
  } catch (error) {
    console.error('Error generating CSV file:', error);
  }
};
